import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  mapDispatchToPropsManagement,
  mapStateToPropsManagement,
} from "../../../modules/profileManagement";
import ParticipantUsers from "../../../components/smart/ParticipantUsers/ParticipantUsers";
import AdminUsers from "../../../components/smart/AdminUsers/AdminUsers";
import { sendNotification } from "../../../components/ToastManager/ToastManager";
import styled from "styled-components";

const ContentWithPadding = styled.div`
  padding: 0 20px 30px 60px;
  margin-top: 2.5rem;

  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    padding: 0;
  }
`;

const Management = (props) => {
  const { fetchAvailableRoles, fetchAvailableStudies, status, resetStatus } =
    props;

  useEffect(() => {
    fetchAvailableRoles();
    fetchAvailableStudies();

    if (status.status) {
      sendNotification(status.status?.text, status.status?.type);
      resetStatus();
    }
  }, [fetchAvailableRoles, fetchAvailableStudies, status, resetStatus]);

  return (
    <>
      <ContentWithPadding>
        <AdminUsers />
        <ParticipantUsers />
      </ContentWithPadding>
    </>
  );
};

export default connect(
  mapStateToPropsManagement,
  mapDispatchToPropsManagement
)(Management);
